import { Navigate, useNavigate } from "react-router-dom";
import { ArrowRight, Cloud, Smartphone } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import AuthFrame from "@/components/AuthFrame";
import { Button } from "@/components/ui/button";
import { isNativeApp } from "@/lib/hiveflowNative";

export default function Welcome() {
  const navigate = useNavigate();
  const { user, isGuest, continueAsGuest } = useAuth();
  const native = isNativeApp();

  if (user || isGuest) return <Navigate to="/" replace />;

  const startGuest = () => {
    if (continueAsGuest()) navigate("/", { replace: true });
  };

  return (
    <AuthFrame
      title="Welkom bij Bijen App"
      subtitle={native ? "Kies hoe je wilt beginnen. Je kunt later altijd een account aanmaken." : "Log in of maak een account aan om verder te gaan."}
      heroTitle="Je bijenwerk, op jouw manier."
      heroText="Begin lokaal op je telefoon of bewaar en synchroniseer alles veilig met een account."
    >
      <div className="space-y-3">
        {native && (
          <button type="button" onClick={startGuest} className="w-full rounded-2xl border-2 border-amber-500 bg-amber-50 p-4 text-left transition hover:bg-amber-100" data-testid="continue-as-guest">
            <span className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-600 text-white"><Smartphone className="h-5 w-5" /></span>
              <span className="min-w-0 flex-1">
                <span className="block font-bold text-zinc-950">Doorgaan zonder account</span>
                <span className="mt-0.5 block text-xs leading-5 text-zinc-600">Gegevens blijven alleen op deze telefoon. Geen cloudback-up of teams.</span>
              </span>
              <ArrowRight className="h-5 w-5 shrink-0 text-amber-700" />
            </span>
          </button>
        )}

        <button type="button" onClick={() => navigate("/register")} className="w-full rounded-2xl border border-zinc-200 bg-white p-4 text-left transition hover:border-zinc-300" data-testid="welcome-register">
          <span className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-zinc-100 text-zinc-700"><Cloud className="h-5 w-5" /></span>
            <span className="min-w-0 flex-1">
              <span className="block font-bold text-zinc-950">Account aanmaken</span>
              <span className="mt-0.5 block text-xs leading-5 text-zinc-600">Cloudback-up, synchronisatie, meerdere apparaten en teams.</span>
            </span>
            <ArrowRight className="h-5 w-5 shrink-0 text-zinc-400" />
          </span>
        </button>

        <Button type="button" variant="outline" onClick={() => navigate("/login")} className="h-12 w-full rounded-xl font-bold">
          Ik heb al een account
        </Button>
      </div>
    </AuthFrame>
  );
}
